module.exports = __webpack_public_path__ + "img/label001.acd667dc.png";